import { getAgencySession } from "../../../utils/agencySession.ts";

/** Presentation state bootstrapped from the server-validated agency cookie. */
export function isAgencyShopSession(): boolean {
  return getAgencySession() !== null;
}

/** Company staff shop session: authenticated without linked PersonId. */
export function isStaffShopSession(): boolean { return false; }


export const getShopOrdersPath = () =>
  "/account/orders";

export const getShopLoginPath = () =>
  "/login";

/** Staff order list/detail/edit. */
export const isStaffOrdersRoute = (pathname: string) =>
  pathname === "/orders" ||
  /^\/order\/[^/]+(\/edit)?$/.test(pathname);
